module.exports = __webpack_public_path__ + "pilihtravel-main-background.4caac206b4ab739bdac1.jpg";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/pilihtravel-main-background.jpg
// module id = ../../../../../src/assets/images/pilihtravel-main-background.jpg
// module chunks = 2